import {
	Box,
	Button,
	Container,
	Paper,
	Stack,
	Typography,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../Components/Logo';

const LegalPageLayout = ({ title, children }) => {
	const navigate = useNavigate();

	return (
		<Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 6 }}>
			<Container maxWidth="sm">
				<Stack spacing={3} alignItems="center" sx={{ mb: 4 }}>
					<Logo
						sx={{ width: 120, cursor: 'pointer' }}
						onClick={() => navigate('/')}
					/>
					<Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
						{title}
					</Typography>
				</Stack>
				<Paper sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>{children}</Paper>
				<Stack
					direction="row"
					spacing={2}
					justifyContent="center"
					sx={{ mt: 3 }}
				>
					<Button component={Link} to="/" variant="text">
						Back to home
					</Button>
					<Button component={Link} to="/privacy" variant="text">
						Privacy
					</Button>
					<Button component={Link} to="/terms" variant="text">
						Terms
					</Button>
				</Stack>
			</Container>
		</Box>
	);
};

export default LegalPageLayout;
